import { render } from "./AffectedObjectsModal.vue?vue&type=template&id=d6bd7654"
import script from "./AffectedObjectsModal.vue?vue&type=script&lang=js"
export * from "./AffectedObjectsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__